import type { BetterstartPluginDefinition } from '@plugin-engine/types.js'

export const portfolioPlugin: BetterstartPluginDefinition = {
  id: 'portfolio',
  title: 'Portfolio',
  description: 'Portfolio content module',
  kind: 'content',
  version: '1.0.0',
  dependencies: [],
  conflicts: [],
  schemaFiles: ['portfolio.json'],
  files: [],
  packageDependencies: [],
  devDependencies: [],
  envSections: [],
  configure: 'none'
}
